import { BaseDto } from '../../core';
import { BUSINESS_TYPE } from '../../shared';
import { EmergencyContactDto } from '.';

export class BuyerCompanyUpdateDto extends BaseDto<BuyerCompanyUpdateDto> {
  name?: string;
  ceoFirstName?: string;
  ceoLastName?: string;
  businessType?: BUSINESS_TYPE[];
  countryCode?: string;
  city: string;
  address1?: string;
  address2?: string;
  zipcode?: string;
  callingCode?: string;
  phone?: string;
  registrationNumber?: string;
  faxCallingCode?: string;
  fax?: string;
  website?: string;
  emergencyContact?: EmergencyContactDto[];
  anniversary?: Date;
}
